export const API_URL = 'https://potm.yangasc.africa';

